import { render, staticRenderFns } from "./ContentFeedGalleryItem.vue?vue&type=template&id=3bfd17d5&scoped=true&"
import script from "./ContentFeedGalleryItem.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedGalleryItem.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedGalleryItem.vue?vue&type=style&index=0&id=3bfd17d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd17d5",
  null
  
)

export default component.exports